module.exports = __webpack_public_path__ + "fonts/VetoSansCond-MediumItalic.c3810da4.woff";